import { trackEvent } from './analytics'
import moment from 'moment'

document.addEventListener('turbolinks:load', () => {
  // Track the source type and date range on report pages.
  if (window.location.pathname.includes('/reports')) {
    if (document.querySelector('#filter-start-date')) {
      const from_date = moment(
        document.querySelector('#filter-start-date').value,
        'MMM D, YYYY'
      )
      const to_date = moment(
        document.querySelector('#filter-end-date').value,
        'MMM D, YYYY'
      )
      const dateRange = to_date.diff(from_date, 'days') + 1
      trackEvent('reports', 'view', 'dateRange', null, dateRange)
    }

    if (document.querySelector('#sources')) {
      const sources = document.querySelector('#sources').value
      trackEvent('reports', 'view', 'sources', sources, null)
    }
  }
})
